const LOCALES: Record<any, any> = {
  en: {
    everyText: "every",
    emptyMonths: "every month",
    emptyMonthDays: "every day of the month",
    emptyMonthDaysShort: "day of the month",
    emptyWeekDays: "every day of the week",
    emptyWeekDaysShort: "day of the week",
    emptyHours: "every hour",
    emptyMinutes: "every minute",
    emptyMinutesForHourPeriod: "every",
    yearOption: "year",
    monthOption: "month",
    weekOption: "week",
    dayOption: "day",
    hourOption: "hour",
    minuteOption: "minute",
    rebootOption: "reboot",
    prefixPeriod: "Every",
    prefixMonths: "in",
    prefixMonthDays: "on",
    prefixWeekDays: "on",
    prefixWeekDaysForMonthAndYearPeriod: "and",
    prefixHours: "at",
    prefixMinutes: ":",
    prefixMinutesForHourPeriod: "at",
    suffixMinutesForHourPeriod: "minute(s)",
    errorInvalidCron: "Invalid cron expression",
    clearButtonText: "Clear",
    weekDays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    altWeekDays: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
    altMonths: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
  },
  es: {
    everyText: "cada",
    emptyMonths: "cada mes",
    emptyMonthDays: "cada día del mes",
    emptyMonthDaysShort: "día del mes",
    emptyWeekDays: "cada día de la semana",
    emptyWeekDaysShort: "día de la semana",
    emptyHours: "cada hora",
    emptyMinutes: "cada minuto",
    emptyMinutesForHourPeriod: "cada",
    yearOption: "año",
    monthOption: "mes",
    weekOption: "semana",
    dayOption: "día",
    hourOption: "hora",
    minuteOption: "minuto",
    rebootOption: "reinicio",
    prefixPeriod: "Cada",
    prefixMonths: "en",
    prefixMonthDays: "el",
    prefixWeekDays: "el",
    prefixWeekDaysForMonthAndYearPeriod: "y",
    prefixHours: "a las",
    prefixMinutes: ":",
    prefixMinutesForHourPeriod: "a los",
    suffixMinutesForHourPeriod: "minuto(s)",
    errorInvalidCron: "Expresión cron inválida",
    clearButtonText: "Limpiar",
    weekDays: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    altWeekDays: ["DOM", "LUN", "MAR", "MIÉ", "JUE", "VIE", "SÁB"],
    altMonths: ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"],
  },
  pt: {
    everyText: "cada",
    emptyMonths: "todo mês",
    emptyMonthDays: "todo dia do mês",
    emptyMonthDaysShort: "dia do mês",
    emptyWeekDays: "todo dia da semana",
    emptyWeekDaysShort: "dia da semana",
    emptyHours: "cada hora",
    emptyMinutes: "cada minuto",
    emptyMinutesForHourPeriod: "cada",
    yearOption: "ano",
    monthOption: "mês",
    weekOption: "semana",
    dayOption: "dia",
    hourOption: "hora",
    minuteOption: "minuto",
    rebootOption: "reinicialização",
    prefixPeriod: "A cada",
    prefixMonths: "em",
    prefixMonthDays: "no",
    prefixWeekDays: "na",
    prefixWeekDaysForMonthAndYearPeriod: "e",
    prefixHours: "às",
    prefixMinutes: ":",
    prefixMinutesForHourPeriod: "aos",
    suffixMinutesForHourPeriod: "minuto(s)",
    errorInvalidCron: "Expressão cron inválida",
    clearButtonText: "Limpar",
    weekDays: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    altWeekDays: ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"],
    altMonths: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
  },
};

export default LOCALES;
